import React from "react";
import { styled } from "@mui/material";

const FloatingActionBarGridWrapper = styled("div")`
  display: flex;
  gap: ${(props) => props.theme.wsc.spacing[1]};
`;

const Divider = styled("div")`
  width: 1px;
  background-color: ${(props) => props.theme.wsc.palette.neutral[500]};
  margin: 6px 0;
`;

const Item = styled("div")`
  display: flex;
  align-items: center;
`;

type FloatingActionBarGridProps = {
  children: React.ReactNode;
};

function FloatingActionBarGrid({ children }: FloatingActionBarGridProps) {
  const validChildren = React.Children.toArray(children).filter((child) =>
    React.isValidElement(child),
  );

  return (
    <FloatingActionBarGridWrapper>
      {validChildren.map((child, index) => (
        <React.Fragment key={index}>
          <Item>{child}</Item>
          {index < validChildren.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </FloatingActionBarGridWrapper>
  );
}

export default FloatingActionBarGrid;
